import Head from 'next/head'

interface SeoProps {
  title: string
  description: string
  keywords: string
  canonicalURL?: string
}
export const Seo = ({
  title,
  description,
  keywords,
  canonicalURL,
}: SeoProps) => {
  return (
    <Head>
      <title>{title}</title>
      <meta name='description' content={description ?? ''} />
      <meta name='keywords' content={keywords ?? ''} />
      <meta name='author' content='ptt ev' />
      <link rel='canonical' href={canonicalURL ?? ''} />
    </Head>
  )
}
